import http from '@/utils/services/http'

export function list (limit, page, filtros) {
  return http.get(`/api/empresa-reboque?page=${page}&limit=${limit}${filtros}`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
}

export function listSimple () {
  return http.get(`/api/empresa-reboque/list-simple`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function cadastrar (data, id = null) {
  if (id) return update(data, id)
  return http.post('/api/empresa-reboque', JSON.stringify(data))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
}

export function find (id) {
  id = parseInt(id)
  if (id < 1) return Promise.reject()
  return http.get(`/api/empresa-reboque/${id}`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
}

export function update (data, id) {
  return http.patch(`/api/empresa-reboque/${id}`, JSON.stringify(data))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
}

export function deleteEmpresaReboque (id) {
  return http.delete(`/api/empresa-reboque/${id}`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
}



// WEBPACK FOOTER //
// ./src/domain/empresa-reboque/services/empresa-reboque.js